import * as React from "react";
import { forwardRef } from "react";
const SvgPlan = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 512, height: 512, x: 0, y: 0, viewBox: "0 0 682.667 682.667", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", className: "", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a", clipPathUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M0 512h512V0H0Z", fill: "#ffffff", opacity: 1, "data-original": "#000000" }))), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#a)", transform: "matrix(1.33333 0 0 -1.33333 0 682.667)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h-207.639c-26.39 0-47.763 21.401-47.763 47.792m456.946 246.246h40.054V0H33.959m-212.797 294.038h316.291", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(262.902 61.202)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v150.151c-8.022 6.067-17.972 9.639-28.8 9.639-26.391 0-47.764-21.374-47.764-47.764v-294.04c0 26.391 21.373 47.765 47.764 47.765 10.828 0 20.778-3.571 28.8-9.638v109.899", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(84.064 291.008)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M124.004 231.055h85.918v85.918h-85.918z", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h-101.509m59.301-35.773h-59.301M0 35.801h-101.509", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(352.024 274)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v102.474m-64.091 0v-238.906H0v102.445", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(464.446 293.53)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 31.691-62.362L63.298-.142", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(400.723 156.361)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v35.206c0 10.772-8.815 19.588-19.587 19.588h-24.889c-10.8 0-19.615-8.816-19.615-19.588V0Z", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(464.446 396.004)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M115.699 93.999h61.143v47.169h-61.143z", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M176.841 93.999h61.172v97.399h-61.172zM238.014 93.999h61.144v76.564h-61.144z", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M299.157 93.999h61.144v47.169h-61.144z", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-157.407", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(432.415 355.24)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 12.132-12.133 24.264 24.265", style: {
  strokeWidth: 14.995,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(148.75 274)", fill: "none", stroke: "#ffffff", strokeWidth: 14.995, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1, className: "" }))));
const ForwardRef = forwardRef(SvgPlan);
export default ForwardRef;
